/* Copyright(c) 2019 APSS Media Pvt. Ltd.
*  All Rights Reserved
*/
/*@author Sanobar Golandaj
*@fileName :voicelogsUpload.js
 *Desc: added validations 
*/
import React from 'react';
import Footer from '../layouts/footer'; 
import PublisherNavigation from '../layouts/publisherNavPage';
// import { MDBRow, MDBCol, MDBBtn } from "mdbreact"; //Nilesh-4240-Removing console warnings
import { MDBRow, MDBCol } from "mdbreact";
// import LeadTable from  './table';  //Nilesh-4240-Removing console warnings
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logoutUser } from '../login/authentication';
import { withRouter } from 'react-router-dom'; 
// import fs from 'fs';  //Nilesh-4240-Removing console warnings
import { saveAs } from 'file-saver';
// import { Table, TableBody, TableHead  } from 'mdbreact'; //Nilesh-4240-Removing console warnings
import { Table } from 'mdbreact';
import './loader.css';
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { fetch_custom as fetch } from "../../configration/fetch_default_headers"; //sonali-task-3945-added default header

// const queryString = require('query-string');  //Nilesh-4240-Removing console warnings
const xlsx =require('xlsx');
const Swal = require('sweetalert2');

// var url = require("url"); //Nilesh-4240-Removing console warnings
// var path = require("path");  //Nilesh-4240-Removing console warnings

// var leadLength; //Nilesh-4240-Removing console warnings
// var leadFileExt;   //Nilesh-4240-Removing console warnings
class  VoiceLogsUpload extends React.Component
        {
            constructor() {

                super();
                this.state = { 
                    campID:'',
                    parentCampID:'',
                    reallocationID:'',
                    selectedFile: null, 
                    filesData:[],
                     fields: {}, 
                     leadDetails:[],
                     leadDetailsData:[],
                     getExt:[],
                     leadDetailsData1:[],
                     leadDetailsDataTest:[],
                     errors: {} ,
                     fileerrors:{},
                     formaterrors:{},
                     inputClass:"disabled",
                     loading:" ",
                     alertBorder:"",
                     searchText: "",//Anshul-5871: added to store search text
                    uploadErrors: [], //Nilesh-5908- added to store upload errors
                    loader2: "", //Nilesh-5908- added loader
                   };
                     this.submitVoiceLogLink = this.submitVoiceLogLink.bind(this);
                     this.submitLinkdetails=this.submitLinkdetails.bind(this);
                     this.downloadAuditReport=this.downloadAuditReport.bind(this);
                     this.Backbutton=this.Backbutton.bind(this);//shivani-task 3183- added this line to bind back button function.
                    
                
            } 
            //shivani-task 3183-added link on back button through this function.
            Backbutton(e){
              e.preventDefault();
              // var parsed = queryString.parse(this.props.location.search);  //Nilesh-4240-Removing console warnings
              //Sonali-3945-accessing parameters from props
              var campID=this.props.location.state.campID;
              var parentCampID=this.props.location.state.parentCampID;                
              var reallocationID=this.props.location.state.reallocationID;
              this.setState({reallocationID,campID});  
              this.props.history.push("/publisherCampaignList",{campID:campID,parentCampID:parentCampID,reallocationID:reallocationID}); //sonali-task-3945-replace query params
              // Akash-bug-4167- path changed 
            }

            downloadAuditReport(e){
              e.preventDefault();
              var campID = e.target.id;
            
             //Sonali-3945-accessing parameters from props
              var parentCampID=this.props.location.state.parentCampID;            
              var reAllocationID=this.props.location.state.reallocationID;
              // const {isAuthenticated, user} = this.props.auth;  //Nilesh-4240-Removing console warnings
              
              let data={
                campID:campID,
                parentCampID:parentCampID,
                reallocationID:reAllocationID,
                listLeadInfoID:this.state.leadDetailsData,
               // user: user//sonali-3945-removing user from the following call
              }
              // fetch("publisher/downloadAuditReport",{//Anshul-5871: updating the route name to downloadVoiceAuditReport
              fetch("publisher/downloadVoiceAuditReport",{
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data)
                }).then(res => res.json())
              .then(downloadFiles =>{
                  this.setState({ downloadFiles: downloadFiles })
            //       /* make the worksheet */
           
            if(downloadFiles.length>0){
            var ws = xlsx.utils.json_to_sheet(downloadFiles);
            /* add to workbook */
            var wb = xlsx.utils.book_new();
            xlsx.utils.book_append_sheet(wb, ws, "Lead");
            
            // /* write workbook */
            var buf = xlsx.write(wb, {bookType:'xlsx', type:'buffer'}); // generate a nodejs buffer
            // var str = xlsx.write(wb, {bookType:'xlsx', type:'binary'});  //Nilesh-4240-Removing console warnings
            /* generate a download */
            function s2ab(s) {
              var buf = new ArrayBuffer(s.length);
              var view = new Uint8Array(buf);
              for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
              return buf;
            }
            var fileName="Audit_Report"+parentCampID+"-"+reAllocationID+".xlsx";
            saveAs(new Blob([s2ab(buf)],{type:"application/octet-stream"}), fileName);
          }else{
            console.log("Data Not Exists");
          }
              }
                )
              
                // window.location.href = '/publisherView?pID='+user.id;
  } /**  End of downloadAuditReport */
 

 submitLinkdetails(i, e) {
     // const { name, value } = e.target;
     // var dynamicArray = this.state.leadDetailsData;
     // var leadInfoID = dynamicArray[i].leadInfoID;
     // let leadDetailsData = [...this.state.leadDetailsData];
     // leadDetailsData[i] = { ...leadDetailsData[i], [name]: value };
     // this.setState({ leadDetailsData });
     // var number = document.getElementById("errorMessage" + leadInfoID);
     // number.innerHTML = "";
 
     // Anshul-5871: added below code to filter data on UI
     const { name, value } = e.target;
     const leadInfoID = this.state.leadDetailsData[i].leadInfoID;
 
     const updatedOriginal = this.state.leadDetailsDataOriginal.map(item =>
       item.leadInfoID === leadInfoID
         ? { ...item, [name]: value }
         : item
     );
 
     const updatedFiltered = this.state.leadDetailsData.map(item =>
       item.leadInfoID === leadInfoID
         ? { ...item, [name]: value }
         : item
     );
 
     this.setState({
       leadDetailsDataOriginal: updatedOriginal,
       leadDetailsData: updatedFiltered
     });
 
     document.getElementById("errorMessage" + leadInfoID).innerHTML = "";
   }
 
 
   submitVoiceLogLink(e){
     e.preventDefault();
     let errors={};
     // const {isAuthenticated, user} = this.props.auth;  //Nilesh-4240-Removing console warnings
     var linkInvalid;
     var voiceValidate=false;
     // var dynamicArray=this.state.leadDetailsData;
     var dynamicArray = this.state.leadDetailsDataOriginal;
 
  
     if(dynamicArray==""||dynamicArray==null||dynamicArray==undefined)
     {
       Swal.fire({
               
         text:"No Data Exists",
         type: 'error',
         confirmButtonText: 'Ok',
         allowOutsideClick: false,
       })
       
     }
    
    
    
   
 
     for(var i=0;i<dynamicArray.length;i++)
     {
 
   
       if(dynamicArray[i].voiceLogLink=="" || dynamicArray[i].voiceLogLink==null || dynamicArray[i].voiceLogLink==undefined)
       {
          errors["voicelogValidate"]="Please enter voice log link";
          this.setState({errors:errors,
           alertBorder:'1px solid red'})
       }
       else{
        
           voiceValidate=true;
           this.setState({errors:'',alertBorder:''})
 
      
        
       }
       
       
       if(voiceValidate==true)
       {
        
         this.setState({errors:'',alertBorder:''})
         var leadInfoID=dynamicArray[i].leadInfoID;
         if(dynamicArray[i].voiceLogLink){
           var link=dynamicArray[i].voiceLogLink;
           var file=link.split('\\').pop().split('/').pop();
           var emailId=dynamicArray[i].email;
         
 
            if (link.toLowerCase() == 'na') {
            dynamicArray[i].voiceLogLink = 'NA';
          }

          // Anshul-5911: Accept NA value (case-insensitive)
          if (file === emailId || file.toLowerCase() == 'na') //Nilesh-4240-Removing console warnings
          {
          }
          else
          {
            linkInvalid=false;
             // var errorMsg="This file is not valid,filename should be in email format";
             var errorMsg="This link is not valid. Link should be in email format.";//Anshul-5871: changed the error message
             var message = document.getElementById('errorMessage'+leadInfoID);
             var number=document.getElementById("errorMessage"+leadInfoID).innerHTML;  
             if(number=="")
             {
               message.innerHTML += errorMsg;
             }
              
             
 
         
          }
             
         
         }
 
       }
 
      
     }
 
   
 
      // Anshul-5907: added voiceValidate condition to avoid blank voice log link submission
    if (linkInvalid == false || voiceValidate == false ) { }
    else {
      let data = {
        dynamicArray: dynamicArray,
        // user:user,//sonali-3945-removing user from the following call
        campID: this.state.campID
      };
 
     fetch("/leadDownloadDetails/submitVoiceLink",{
       method:'POST',
       headers: {"Content-Type": "application/json"},
       body: JSON.stringify(data)
     }) 
     .then(res => res.json()).then(res => {
     
       if (res.success === true) {
         Swal.fire({           
           text: "Link Submitted Successfully",
           type: 'success',
           confirmButtonText: 'Ok',
           allowOutsideClick: false,  
           preConfirm: () => {
             window.location.reload();
           
           }
         })
     
         
       }
     })
   }//else
   }
        
                componentDidMount() {
                        if(!this.props.auth.isAuthenticated) {
                        this.props.history.push('/userLogin');
                  }
                  else {    
                    	//Sonali-3945-VAPT-accessing parameters from location.state
                  if (this.props.location.state !== undefined) {
                    const {
                    campID,parentCampID,reallocationID
                    } = this.props.location.state;
                    this.setState({campID,parentCampID,reallocationID})
			}            
                //  var parsed = queryString.parse(this.props.location.search);
                //Sonali-3945-accessing parameters from props
                  // var campID=this.props.location.state.campID; //Nilesh-4240-Removing console warnings

                  var parentCampID=this.props.location.state.parentCampID;//sunita-task-3184-taken id as per requirement getting as undefined.
                  var reallocationID=this.props.location.state.reallocationID;//sunita-task-3184-taken id as per requirement getting as undefined.
                 this.setState({parentCampID,reallocationID});
                
                // const {isAuthenticated, user} = this.props.auth; //Nilesh-4240-Removing console warnings
               
                       this.setState({campID:this.props.location.state.campID});
                        let data={
                          campID:this.props.location.state.campID,
                          //parentCampID:parentCampID,
                          //reallocationID:reallocationID,
                          //user:user//sonali-3945-removing user from the following call
                        }
                        fetch("/leadDownloadDetails/voiceLogData",{
                          method: 'POST',
                           headers: {'Content-Type': 'application/json'},
                           body: JSON.stringify(data)
                        }).then(res => res.json())
                        .then(leadDetailsData =>{
                          this.setState({ leadDetailsData: leadDetailsData, leadDetailsDataOriginal: leadDetailsData })//Anshul-5871: added leadDetailsDataOriginal
                        });
                }
              }
               // Anshul-5871: added handleChangeSearch
  handleChangeSearch = (e) => {
    const searchText = e.target.value.toLowerCase();

    const filteredData = this.state.leadDetailsDataOriginal.filter(row =>
      Object.values(row).some(value =>
        value &&
        value.toString().toLowerCase().includes(searchText)
      )
    );

    this.setState({
      searchText,
      leadDetailsData: filteredData
    });
  };   
  //Nilesh-5908- File download function
  //   handleDownload = () => {
  //   const { leadDetailsData } = this.state;

  //   if (!leadDetailsData || leadDetailsData.length === 0) {
  //     Swal.fire({
  //       text: "No data to download",
  //       type: "error",
  //       confirmButtonText: "Ok",
  //     });
  //     return;
  //   }

  //   const parentCampID = leadDetailsData[0].parentCampID || "UNKNOWN";
  //   // Prepare Excel rows (same as UI)
  //   const excelData = leadDetailsData.map(item => ({
  //     LeadInfoID: item.leadInfoID,
  //     "Campaign ID"	: item.parentCampID,
  //     Email: item.email,
  //     Status: item.status,
  //     VoiceLogLink: item.voiceLogLink || "",
  //   }));

  //   const worksheet = xlsx.utils.json_to_sheet(excelData);
  //   const workbook = xlsx.utils.book_new();
  //   xlsx.utils.book_append_sheet(workbook, worksheet, "Leads");

  //   const excelBuffer = xlsx.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const blob = new Blob([excelBuffer], {
  //     type:
  //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   saveAs(blob, `Voice_Log_Details_Leads_${parentCampID}.xlsx`);
  // };             

  //Nilesh-5908- New File download function
  handleDownload = () => {
    const { campID } = this.state;
    this.setState({ loader2: "loader_review" });

    fetch(`/leadDownloadDetails/downloadVoiceLogLeads?campID=${campID}`, {
      method: "POST",
    })
      .then(async (response) => {
        // Anshul-5907: commented below log
        // console.log(JSON.stringify(response));
        if (!response.ok) {
          throw new Error("Failed to download file");
        }
        // Get filename from content-disposition if present
        let filename = `Voice_Log_Details_Leads_${campID}.xlsx`;
        const disposition = response.headers.get("content-disposition");
        if (disposition && disposition.indexOf("filename=") !== -1) {
          filename = disposition.split("filename=")[1].replace(/['"]/g, "").trim();
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        this.setState({ loader2: "" });
      })
      .catch((err) => {
        this.setState({ loader2: "" });
        Swal.fire({
          text: "Error downloading voice log leads file.",
          type: "error",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
      });
  };



  //Nilesh-5908- Excel file upload function
  handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Clear old errors immediately
    this.setState({ uploadErrors: [] });

    // Allow ONLY .xlsx files
    const allowedType =
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    if (!allowedType) {
      this.setState({
        uploadErrors: ["Only .xlsx Excel file is allowed"],
      });
      e.target.value = null;
      return;
    }

    const reader = new FileReader();

    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);

      // Read workbook
      const workbook = xlsx.read(data, { type: "array" });

      // Take first sheet
      const sheet = workbook.Sheets[workbook.SheetNames[0]];

      // IMPORTANT: defval keeps empty cells
      const excelData = xlsx.utils.sheet_to_json(sheet, {
        defval: "",        // <-- REQUIRED
        raw: false,
      });

      this.validateUploadedExcel(excelData);
    };

    reader.readAsArrayBuffer(file);
    e.target.value = null;
  };

  //Nilesh-5908- Upload file validation function
  validateUploadedExcel = (excelData) => {
    const uploadErrors = [];

    // Check empty file
    if (!excelData || excelData.length === 0) {
      this.setState({
        uploadErrors: ["Uploaded Excel file is empty"],
      });
      return;
    }

    // Required headers
    const requiredHeaders = [
      "Lead Info ID",
      // "Campaign ID",
      // "Email",
      // "Status",
      "Voice Log Link",
    ];

    // Headers from first row (NOW safe due to defval)
    const fileHeaders = Object.keys(excelData[0]);

    // Find missing headers
    const missingHeaders = requiredHeaders.filter(
      (h) => !fileHeaders.includes(h)
    );

    if (missingHeaders.length > 0) {
      this.setState({
        uploadErrors: [
          `Missing header: ${missingHeaders.join(", ")}`,
        ],
      });
      return;
    }

    // UI data (shown on screen)
    const uiData = [...this.state.leadDetailsDataOriginal];
    // Anshul-5907: commented below alert
    //  NEW VALIDATION: lead count
    if (excelData.length > uiData.length) {
      this.setState({
        uploadErrors: [
          "Uploaded file contains more leads than allowed",
        ],
      });
      return;
    }

    // Create map for fast lookup
    const uiLeadMap = {};
    uiData.forEach((item) => {
      uiLeadMap[item.leadInfoID] = item;
    });

    //  Error flags (ONE per type)
    let invalidLeadFound = false;
    let campaignMismatchFound = false;
    let emailMismatchFound = false;
    let emptyLinkFound = false;
    let invalidLinkFound = false;

    // Validate each row
    excelData.forEach((row) => {
      const lead = uiLeadMap[row["Lead Info ID"]];

      // Lead not found on UI
      if (!lead) {
        invalidLeadFound = true;
        return;
      }

      const voiceLink = row["Voice Log Link"]?.trim();

      // Empty check
      if (!voiceLink) {
        emptyLinkFound = true;
        return;
      }

      // Anshul-5911: Accept NA value (case-insensitive)
      if (voiceLink.toLowerCase() === "na") {
        lead.voiceLogLink = "NA"
        return;
      }

      // Filename must match email
      const fileName = voiceLink.split("\\").pop().split("/").pop();

      if (fileName !== lead.email) {
        invalidLinkFound = true;
        return;
      }

      // Valid → update UI data
      lead.voiceLogLink = voiceLink;
    });


    // Collect errors (ONE per type)
    if (invalidLeadFound) {
      uploadErrors.push("Some LeadInfoID from the uploaded file are not visible on the screen");
    }
    if (campaignMismatchFound) {
      uploadErrors.push("The Campaign ID in the uploaded file does not match the selected campaign");
    }
    if (emailMismatchFound) {
      uploadErrors.push("Email mismatch in the uploaded file are not visible on the screen");
    }
    if (emptyLinkFound) {
      uploadErrors.push("Some voice log links are missing in the uploaded file");
    }
    if (invalidLinkFound) {
      uploadErrors.push(
        "Some voice log links are invalid. Please ensure the Link matches the email address"
      );
    }

    //  Stop if errors exist
    if (uploadErrors.length > 0) {
      this.setState({ uploadErrors });
      return;
    }

    // Submit valid data
    this.submitUploadedVoiceLinks(uiData);
    this.setState({ isUploadSuccess: true });
  };


  //Nilesh-5908- Submit uploaded voice links
  submitUploadedVoiceLinks = (dynamicArray) => {
    fetch("/leadDownloadDetails/submitVoiceLink", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        dynamicArray,
        campID: this.state.campID,
      }),
    })
      .then(res => res.json())
      .then(res => {
        if (res.success === true) {
          Swal.fire({
            text: "Excel uploaded successfully",
            type: "success",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            preConfirm: () => window.location.reload(),
          });
        }
      });
  };      
             
render()
    {
      // const {isAuthenticated, user} = this.props.auth; //Nilesh-4240-Removing console warnings
        
      return (
      <div>
        <PublisherNavigation />
        <form method="POST" name="submitVoiceLogLink" onSubmit={this.submitVoiceLogLink}>

          <br />
          <div class="container-fluid" style={{ paddingTop: '90px', marginBottom: '60px' }}>
            <div
              className="row"
              style={{
                alignItems: "center",
                position: "relative",
              }}
            >

              {/* Back Button */}
              <div className="col-lg-2 col-md-2 col-sm-2">
                <a href="#/" onClick={this.Backbutton}>
                  <FaArrowAltCircleLeft size={32} color="#056eb8" />
                </a>
              </div>

              {/* CENTER TITLE */}
              <div
                style={{
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                  pointerEvents: "none",
                }}
              >
                <label
                  id="labelDI"
                  style={{
                    fontSize: "28px",
                    fontWeight: "500",
                    color: "#193D8F",
                    margin: 0,
                  }}
                >
                  Voice Log Details
                </label>
              </div>

              {/* Nilesh-5908-Download and upload icons */}
              <div
                className="col-lg-3 col-md-3 col-sm-3"
                style={{
                  marginLeft: "auto",          // push everything to right
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",  // icons at end
                }}
              >

                {/* Hidden file input */}
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  ref={(ref) => (this.uploadExcelRef = ref)}
                  style={{ display: "none" }}
                  onChange={this.handleExcelUpload}
                />

                {/* ⬇ Download + ⬆ Upload (8px gap) */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",   // EXACT GAP
                  }}
                >
                  <img
                    src="download1.png" //Nilesh-5921-Updated image
                    alt="Download"
                    title="Download Excel"
                    onClick={this.handleDownload}
                    style={{
                      width: "28px",
                      height: "28px",
                      cursor: "pointer",
                    }}
                  />

                  <img
                    src="upload_file.png" //Nilesh-5921-Updated image
                    alt="Upload"
                    title="Upload Excel"
                    onClick={() => {
                      this.setState({ uploadErrors: [] })// clear immediately
                      this.uploadExcelRef.click()
                    }}
                    style={{
                      width: "28px",
                      height: "28px",
                      cursor: "pointer",
                    }}
                  />
                </div>

                {/* Audit Report (20px gap) */}
                <div
                  className="tip"
                  style={{
                    position: "relative",
                    marginLeft: "30px",   // EXACT GAP
                  }}
                >
                  <a href="#/" onClick={this.downloadAuditReport}>
                    <img
                      src="download.jpg"
                      alt="Audit Report"
                      id={this.props.location.state.campID}
                      reallocationID={this.props.location.state.reallocationID}
                      style={{
                        width: "30px",
                        height: "30px",
                        cursor: "pointer",
                      }}
                    />
                  </a>

                  <span
                    className="load"
                    style={{
                      position: "absolute",
                      right: "100%",
                      transform: "translate(-80%, 10%)",
                      marginRight: "6px",
                      zIndex: 9999,
                    }}
                  >
                    Download Audit Report
                  </span>
                </div>
              </div>


            </div>
            {/* Anshul-5871: added search bar */}
            {/* Nilesh-5908 */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                // alignItems: "center",
                // width: "100%",
              }}
            >
              {/* LEFT SIDE – Upload & Download */}

              {/* Nilesh-5908 */}
              {/* RIGHT SIDE – Search */}
              <input
                type="text"
                className="inputstyle4"
                name="search"
                placeholder="Search"
                style={{
                  backgroundImage: "url(searchIcon.png)",
                  backgroundPosition: "15px 8px",
                  backgroundSize: "15px 15px",
                  backgroundRepeat: "no-repeat",
                  width: "200px",
                  height: "28px",
                  fontSize: "12px",
                  border: "1px solid #CCCCCC",
                  padding: "15px 20px 15px 36px",
                  backgroundColor: "#FFFFFF",
                  fontFamily: "sans-serif",
                  borderRadius: "15px",
                }}
                onChange={this.handleChangeSearch}
                onKeyPress={this.handleChangeSearch}
              />
            </div>

            {/* Upload Error Messages (SEPARATE FROM SUBMIT ERRORS) */}
            {this.state.uploadErrors.length > 0 && (
              <div
                style={{
                  border: "1px solid red",
                  color: "red",
                  padding: "8px",
                  marginTop: "10px",
                  borderRadius: "6px",
                  fontSize: "12px",
                }}
              >
                <ul style={{ margin: 0, paddingLeft: "18px" }}>
                  {this.state.uploadErrors.map((err, index) => (
                    <li key={index}>{err}</li>
                  ))}
                </ul>
              </div>
            )}




            <br />
            <div class="errorMessage" style={{ border: this.state.alertBorder }}>
              {this.state.errors.voicelogValidate}
            </div>

            <MDBRow>

              <MDBCol lg="12" className="mb-12">
                <div>


                  {/* Anshu-5871: Added maxHeight to table and aliged table header at centre */}
                  <div style={{ maxHeight: '50vh', overflowY: 'auto', }} className="voice-table-wrapper">
                    {/* <Table scrollY  className=" table table-bordered table-striped "  style={{fontSize:'12px'}} > */}
                    <div style={{ marginLeft: "450px !important" }}
                      id={this.state.loader2}></div>

                    <Table className=" table table-bordered table-striped " style={{ fontSize: '12px' }} >
                      <thead >
                        <tr class="info" style={{ verticalAlign: 'top' }}>
                          <th class="table-header" style={{ width: '10%', textAlign: 'center', verticalAlign: 'top', position: 'sticky', top: 0 }}>Lead ID</th>
                          <th class="table-header" style={{ width: '10%', textAlign: 'center', verticalAlign: 'top', position: 'sticky', top: 0 }}>Campaign ID</th>
                          <th class="table-header" style={{ width: '20%', textAlign: 'center', verticalAlign: 'top', position: 'sticky', top: 0, }}>Email</th>
                          <th class="table-header" style={{ verticalAlign: 'top', textAlign: 'center', position: 'sticky', top: 0, }}>Status</th>
                          <th class="table-header" style={{ verticalAlign: 'top', textAlign: 'center', position: 'sticky', top: 0, }}>Voice Log Link</th>

                        </tr>
                      </thead>
                      {this.state.leadDetailsData.map((leadDetailsData, i) => {
                        return (
                          <tbody key={leadDetailsData.leadInfoID}>
                            <tr key={leadDetailsData.leadInfoID}>

                              {/* Anshul-5871:aligned table data in center  */}
                              <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{leadDetailsData.leadInfoID}</td>

                              <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{leadDetailsData.parentCampID}</td>
                              <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{leadDetailsData.email}</td>

                              <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{leadDetailsData.status}</td>
                              <th style={{}}><input
                                name="voiceLogLink"
                                value={leadDetailsData.voiceLogLink || ""}
                                onChange={(e) => this.submitLinkdetails(i, e)}
                                className="form-control"
                                style={{ height: "25px" }}
                              />
                                <div id={"errorMessage" + leadDetailsData.leadInfoID} style={{ color: 'red' }}></div>

                              </th>

                            </tr>

                          </tbody>
                        )
                      })}
                    </Table>
                  </div>
                  {/* //shivani-3183- added css and aligned submit button . */}
                  {/* Anshul-5871:fixed table to show submit button without scrolling */}
                  {/* Submit button below table */}
                  <div style={{
                    marginTop: '15px', textAlign: 'right'
                  }}
                  >
                    <button class="btn add-button" type="submit">
                      Submit
                    </button>
                  </div>

                  <div style={{ height: '1px' }} aria-hidden="true"></div>

                </div>

              </MDBCol>
            </MDBRow>

          </div>






        </form>
        <Footer />

      </div>
    );
        
    }
}

/**
       * @author Narendra Phadke
       * @param  Description handle the login authentication
       * @return Description return All details of authentication
       */
      VoiceLogsUpload.propTypes = {
        logoutUser: PropTypes.func.isRequired,
        auth: PropTypes.object.isRequired
    }
    
    const mapStateToProps = (state) => ({
        auth: state.auth
    })
 export default connect(mapStateToProps, { logoutUser })(withRouter(VoiceLogsUpload)); 
